import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";
import { findDtwinModel } from "~/modules/dtwin/utils/findDtwinModel";

export function getDtwinTypeLabel(
  models: DtwinModel[],
  dtwin?: Dtwin | null,
): string {
  const model = findDtwinModel(models, dtwin);
  return model?.friendlyName || model?.name || "";
}
